// extracted by mini-css-extract-plugin
module.exports = {"mainFooter":"footer_mainFooter__rlrqq","foot":"footer_foot__2nyHR"};